import { 
  LAYOUT_MANAGER_ARRANGE_CONTENT,
  UPDATE_LAYOUT_CONTENT, ADD_CONTENTS_TO_LAYOUT, RESET_LAYOUT_CONTENT, REMOVE_LAYOUT_CONTENTS,
  FETCH_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST, FETCHING_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED, FETCHING_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED,
  FETRCH_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST, FETCHING_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED, FETCHING_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED,
  INVALIDATE_LAYOUT_MANAGER_MAPPINGS, ARRANGE_MAPPINGS_FOR_LAYOUT_MANAGER,
  ARRANGE_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST, ARRANGING_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED, ARRANGING_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED,
  UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED, UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED,
  UPDATE_ALIAS_IN_LAYOUT_CONTENT
} from "constants/actionTypes";

import { updateLayoutManagerForContentGrid } from './contentGrid';

import _ from 'lodash';
import axios from 'axios';

import { put, call, takeEvery, select, take } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import { contentGrid } from "components/Palette/contentGrid";

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const LAYOUT_URL = `${apiUrl}/api/2.0/content/layout`;
const ASSET_MAPPING_BASE_URL = `${apiUrl}/api/2.0/content-mappings`;

/**
 * Rearrange layout content
*/
export const arrangeLayoutContents = createAction(LAYOUT_MANAGER_ARRANGE_CONTENT, (editorSession, widget, content, index) => {
  return {
    editorSession: editorSession,
    widget: widget,
    content: content,
    index: index
  };
})

/**
 * Update layout content
*/
export const updateLayoutContent = createAction(UPDATE_LAYOUT_CONTENT, (editorSession, contentGrid, content, request) =>{
  return {
    editorSession: editorSession,
    contentGrid: contentGrid,
    content: content,
    request: request
  }
})

/**
 * Update Alias layout content
*/
export const updateAliasinLayoutContent = createAction(UPDATE_ALIAS_IN_LAYOUT_CONTENT, (editorSession, content, alias) => {
  return {
    editorSession: editorSession,
    content: content,
    alias: alias
  }
})

/**
 * Add Content to Layout
*/
export const addContentToLayout = createAction(ADD_CONTENTS_TO_LAYOUT, (editorSession, widgetId, mappings) => {
  return {
    editorSession: editorSession,
    widgetId: widgetId,
    mappings: mappings
  }
})

/**
 * Reset layout content
*/
export const resetLayoutContent = createAction(RESET_LAYOUT_CONTENT, (editorSession, widgetId, contentId) => {
  return {
    editorSession: editorSession,
    widgetId: widgetId,
    contentId: contentId
  }
})

/**
 * Reset layout content
*/
export const removeLayoutContents = createAction(REMOVE_LAYOUT_CONTENTS, (editorSession, widgetId, contents) => {
  return  {
    editorSession: editorSession,
    widgetId: widgetId,
    contents: contents
  }
});

/**
 * ------------------------------------------------------------
 * Fetch content mapping for layout
 * ------------------------------------------------------------
*/
export const fetchMappingsForLayoutManager = createAction(FETCH_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST, (editorSession, widget, layout, page, limit) => {
  return {
    editorSession: editorSession,
    widget: widget,
    layout: layout,
    page: page,
    limit: limit
  }
});

const fetchingMappingsForLayoutManagerSucceeded = createAction(FETCHING_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED,
  (editorSession, widget, layout, response) => {
    return {
      editorSession: editorSession,
      widget: widget,
      layout: layout,
      response: response
    }
  }
);

const fetchingMappingsForLayoutManagerFailed = createAction(FETCHING_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED,
  (editorSession, widget, layout, error) => {
    return {
      editorSession: editorSession,
      widget: widget,
      layout: layout,
      error: error
    }
  }
);

function* fetchMappingsForLayoutManagerSaga(action) {
  const { editorSession, widget, layout, page, limit } = action.payload;

  const params = {
    page: page,
    limit: limit
  };

  let url = buildUrl(LAYOUT_URL, {
    path: `${layout}/mappings`,
    queryParams: params
  });

  const fetchMappingsForLayoutManagerAPI = () => {
    return axios.post(url, {}).then(response => response.data);
  }

  try {
    const response = yield call(fetchMappingsForLayoutManagerAPI);
    if (response) {
      yield put(fetchingMappingsForLayoutManagerSucceeded(editorSession, widget, layout, response));
    }
  } catch (error) {
    console.log(error);
    yield put(fetchingMappingsForLayoutManagerFailed(editorSession, widget, layout, error));
  }
}

/**
 * ------------------------------------------------------------
 * Fetch Fitlter asset mappings for layout
 * ------------------------------------------------------------
*/
export const fetchFilterMappingsForLayoutManager = createAction(FETRCH_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST, (editorSession, widget, layout, request, page, limit) => {
  return {
    editorSession: editorSession,
    widget: widget,
    layout: layout,
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingFilterMappingsForLayoutManagerSucceeded = createAction(FETCHING_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED,
  (editorSession, widget, layout, response) => {
    return {
      editorSession: editorSession,
      widget: widget,
      layout: layout,
      response: response
    }
  }
);

const fetchingFilterMappingsForLayoutManagerFailed = createAction(FETCHING_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED,
  (editorSession, widget, layout, error) => {
    return {
      editorSession: editorSession,
      widget: widget,
      layout: layout,
      error: error
    }
  }
);

function* fetchFilterMappingsForLayoutManagerSaga(action) {
  const { editorSession, widget, layout, request, page, limit } = action.payload;

  const params = {
    page: page,
    limit: limit
  };

  let url = buildUrl(ASSET_MAPPING_BASE_URL, {
    path: 'search',
    queryParams: params
  });

  const fetchFilterMappingsForLayoutManagerAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchFilterMappingsForLayoutManagerAPI);
    if (response) {
      yield put(fetchingFilterMappingsForLayoutManagerSucceeded(editorSession, widget, layout, response));
    }
  } catch (error) {
    console.log(error);
    yield put(fetchingFilterMappingsForLayoutManagerFailed(editorSession, widget, layout, error));
  }
}


/**
 * ------------------------------------------------------------
 * Arrange content mapping for layout
 * ------------------------------------------------------------
*/
export const arrangeMappings = createAction(ARRANGE_MAPPINGS_FOR_LAYOUT_MANAGER, (editorSession, widget, layout, page, sort, order) => {
  return {
    editorSession: editorSession,
    widget: widget,
    layout: layout,
    page: page,
    sort: sort,
    order: order
  }
});

function* arrangeMappingsSaga(action) {
  const { editorSession, widget, layout, page, sort, order } = action.payload;

  const deletedContents = yield select(state => _.get(state, `${editorSession}.present.layoutManager.deletedMappings`) || []);
  const contents = yield select(state => _.get(state, `${editorSession}.present.layoutManager.items`) || []);
  const storyboard = yield select(state => _.get(state, 'storyboards.storyboard.item', {}));

  var updating = false;
  var successAction = null;

  var mappingRequest = (contents || [])
    .filter(item => item.changes)
    .map((item, index) => {
      return {
        ...item,
        content: _.get(item, 'content.id'),
        fields: (item.fields || []).map(field => {
          if (field.name === 'icon') {
            return {
              ...field,
              content: _.get(field, 'content.id')
            }
          }

          return field;
        })
      }
    });

  if(mappingRequest && mappingRequest.length > 0) {
    updating = true;
    
    var layoutRequest = {
      mappings: mappingRequest,
      page: page,
      storyboard: storyboard.id,
      deletedMappings: deletedContents
    }

    yield put(updateLayoutManagerForContentGrid(editorSession, widget, layout, layoutRequest));

    successAction = yield take([UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED, UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED]);
  } 
    
  if (!updating || (successAction && successAction.type === UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED)) {
    var arrangeRequest = {
      sort: sort,
      order: order,
      layout: layout
    }

    yield put(arrangeMappingsForLayoutManager(editorSession, layout, arrangeRequest));
  }
}

export const arrangeMappingsForLayoutManager = createAction(ARRANGE_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST, (editorSession, layout, request) => {
  return {
    editorSession: editorSession,
    layout: layout,
    request: request
  }
});

const arrangeMappingsForLayoutManagerSucceeded = createAction(ARRANGING_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED,
  (editorSession, layout, response) => {
    return {
      editorSession: editorSession,
      layout: layout,
      response: response
    }
  }
);

const arrangeMappingsForLayoutManagerFailed = createAction(ARRANGING_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED,
  (editorSession, layout, error) => {
    return {
      editorSession: editorSession,
      layout: layout,
      error: error
    }
  }
);

function* arrangeMappingsForLayoutManagerSaga(action) {
  const { editorSession, layout, request } = action.payload;

  let url = buildUrl(LAYOUT_URL, {
    path: `${layout}/arrange`,
  });

  const arrangeMappingsForLayoutManagerAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(arrangeMappingsForLayoutManagerAPI);
    if (response) {
      yield put(arrangeMappingsForLayoutManagerSucceeded(editorSession, layout, response));
    }
  } catch (error) {
    console.log(error);
    yield put(arrangeMappingsForLayoutManagerFailed(editorSession, layout, error));
  }
}

/**
 * ------------------------------------------------------------
 * Invalidate layout manager mappings
 * ------------------------------------------------------------
*/
export const invalidateLayoutManagerMappings = createAction(INVALIDATE_LAYOUT_MANAGER_MAPPINGS);

export default function* layoutManagerSaga() {
  yield takeEvery(FETCH_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST, fetchMappingsForLayoutManagerSaga);
  yield takeEvery(ARRANGE_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST, arrangeMappingsForLayoutManagerSaga);
  yield takeEvery(ARRANGE_MAPPINGS_FOR_LAYOUT_MANAGER, arrangeMappingsSaga);
  yield takeEvery(FETRCH_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST, fetchFilterMappingsForLayoutManagerSaga);
}